import { useEffect, useState } from "react";
import { gxAppStatusApi } from "@/app/apiConfig/services/paymentsAbstractApiLayer";
import { gxIsArray } from "@/app/utils/helpers";
import type { BeneficiaryStatusResponse } from "@/app/types/beneficiaries";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
import DashboardWidgetRenderer from "./DashboardWidgetRenderer";
import { DASHBOARD_WIDGET_REGISTRY } from "./dashboardWidgetRegistryConfig/dashboardWidgetRegistry.config";
import { useDashboardLayoutData } from "./types/useDashboardLayoutData";
import "./alternative-components/styles/AlternativStyle.scss";

const CARD_MENU_IDS = new Set([205, 206, 207, 61]);

function ApprovalsWorkspace() {
  const [statusList, setStatusList] = useState<BeneficiaryStatusResponse[]>([]);
  const [callCount, setCallCount] = useState<boolean>(false);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);

  const { menuDetail, loading } = useDashboardLayoutData();

  const getAllStatus = async () => {
    try {
      const payload = { type: "PAY" };
      const result = await gxAppStatusApi(payload);
      if (gxIsArray(result?.data)) {
        setStatusList(result.data);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getAllStatus();
  }, []);

  const callRecent = !openSuccessModal;

  const handleApprovalAction = () => {
    setOpenSuccessModal(true);
    setCallCount(true);
    setTimeout(() => {
      setOpenSuccessModal(false);
      setCallCount(false);
    }, 0);
  };

  if (loading) {
    return (
      <div className="gx-bene-form-container-loading-overlay">
        <SubmitLoading />
      </div>
    );
  }

  const cardMenus = menuDetail.filter((m: { menuId: number }) =>
    CARD_MENU_IDS.has(m.menuId),
  );
  const panelMenus = menuDetail.filter(
    (m: { menuId: number }) => !CARD_MENU_IDS.has(m.menuId),
  );

  return (
    <div className="gx-approval-main-container">
      <div className="dashboard-container">
        <div className="alter-grid-payable">
          <DashboardWidgetRenderer
            menuDetail={cardMenus}
            registry={DASHBOARD_WIDGET_REGISTRY}
          />
        </div>
      </div>

      <DashboardWidgetRenderer
        menuDetail={panelMenus}
        registry={DASHBOARD_WIDGET_REGISTRY}
        extraProps={{
          66: {
            onApprove: handleApprovalAction,
            onReject: handleApprovalAction,
            onApproveAll: handleApprovalAction,
          },
          64: {
            callRecent,
            statusList,
            callCount,
          },
        }}
      />
    </div>
  );
}

export default ApprovalsWorkspace;
